import { VestmentCategory } from '../../../enum/vestmentCategory';
import { CUSTOMER_SIZE_ID, forCustomerForSizeSelection } from '../../size';
import type { OrderItemCategoryConfig, OrderItemFormValues } from '../types';
import { albConfig } from './alb';
import { chasubleConfig } from './chasuble';
import { mitreConfig } from './mitre';
import { stoleConfig } from './stole';

export const ORDER_ITEM_REGISTRY: Record<
  VestmentCategory,
  OrderItemCategoryConfig
> = {
  [VestmentCategory.Chasuble]: chasubleConfig,
  [VestmentCategory.Alb]: albConfig,
  [VestmentCategory.Stole]: stoleConfig,
  [VestmentCategory.Mitre]: mitreConfig,
};

export function emptyOrderItemFormValues(
  category: VestmentCategory,
  customerId?: string | number | null
): OrderItemFormValues {
  const values = ORDER_ITEM_REGISTRY[category].emptyFormValues();
  const forCustomer = forCustomerForSizeSelection(CUSTOMER_SIZE_ID, customerId);
  if (!forCustomer) {
    return values;
  }
  return {
    ...values,
    size: CUSTOMER_SIZE_ID,
    forCustomer,
  };
}
